import { Link } from 'react-router-dom';
import { useEnquiryModal } from '@/hooks/useEnquiryModal';
import FadeInSection from '@/components/base/FadeInSection';

const businessTypes = [
  { icon: 'ri-flashlight-line', label: 'Quick Commerce Companies' },
  { icon: 'ri-restaurant-line', label: 'Restaurants' },
  { icon: 'ri-hotel-line', label: 'Hotels' },
  { icon: 'ri-store-2-line', label: 'Cloud Kitchens' },
  { icon: 'ri-shopping-bag-3-line', label: 'Retail Stores' },
  { icon: 'ri-building-2-line', label: 'Supermarkets' },
  { icon: 'ri-exchange-line', label: 'Wholesale Markets' },
  { icon: 'ri-bowl-line', label: 'Food Businesses' },
];

export default function BulkSupplyCTA() {
  const { openEnquiry } = useEnquiryModal();
  return (
    <section className="w-full relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-primary-950">
        <img
          src="/images/home-bulk-cta-bg.jpg"
          alt="Bulk fresh produce supply – Bassi Enterprises logistics"
          title="Bassi Enterprises – Bulk Fresh Produce Supply Chain"
          className="w-full h-full object-cover object-top opacity-20"
        />
      </div>

      <FadeInSection className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
        <div className="max-w-5xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 bg-primary-500/20 text-primary-300 text-xs font-semibold rounded-full mb-4 border border-primary-500/30">
            Bulk Supply
          </span>

          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
            Looking For A <strong className="text-primary-400">Reliable Fresh Produce</strong> Partner?
          </h2>

          <p className="text-background-50/70 text-sm md:text-base max-w-3xl mx-auto mb-9">
            We provide bulk fruits and vegetables supply solutions for businesses of all sizes. From quick-commerce platforms to local retailers — we deliver freshness at scale.
          </p>

          {/* Business Types Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mb-10 max-w-3xl mx-auto">
            {businessTypes.map((item) => (
              <div
                key={item.label}
                className="flex items-center gap-2.5 px-4 py-3 rounded-xl bg-background-50/5 border border-background-50/10 hover:bg-background-50/10 transition-all duration-300 cursor-pointer"
              >
                <div className="w-7 h-7 rounded-lg bg-primary-500/20 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-primary-400 text-sm`}></i>
                </div>
                <span className="text-background-50/80 text-xs md:text-sm text-left whitespace-nowrap">{item.label}</span>
              </div>
            ))}
          </div>

          <button
            onClick={() => openEnquiry()}
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-primary-400 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
          >
            <i className="ri-group-line text-lg md:text-xl"></i>
            Become A Business Partner
          </button>
        </div>
      </FadeInSection>
    </section>
  );
}